import {OrderProfileEnum} from "@/constants/commerce-enum";

//Footer "با الانزا" static data
export const elanza = {
    main_title : 'با الانزا',
    items: [
        {
            id: 1,
            title: 'کارت هدیه',
            href: '/category/gift-card'
        },
        {
            id: 2,
            title: 'مجله',
            href: 'https://elanza.com/mag/'
        },
        {
            id: 3,
            title: 'همکاری با الانزا',
            href: '/jobs'
        },
        {
            id: 4,
            title: 'درباره ما',
            href: '/about-us'
        },
        {
            id: 5,
            title: 'ارسال و بازگشت کالا',
            href: '/return'
        },
        {
            id: 6,
            title: 'حریم خصوصی',
            href: '/privacy'
        },
        {
            id: 7,
            title: 'شرایط و ضوابط',
            href: '/terms'
        },
    ]
}

//Footer "تماس با ما" static data
export const contactUs = {
    main_title : 'تماس با ما',
    items: [
        {
            id: 1,
            title: 'آدرس ایمیل:cs@elanza.com',
            href:"mailto:cs@elanza.com"
        },
        {
            id: 2,
            title: 'تلفن تماس:۰۲۱۹۱۰۰۸۲۹۲',
            href: "tel:02191008292"
        },
        {
            id: 3,
            title: 'آدرس:تهران، ولیعصر، بالاتر از میدان ونک، کوچه خلیل زاده، پلاک ۴۱، طبقه اول',
        },
        {
            id: 4,
            title: 'کدپستی:۱۹۶۹۷۵۴۸۶۴',
        },
    ]
}

//Footer "با ما همراه باشید" static data
export const social = {
    main_title : 'با ما همراه باشید',
    items  : [
        {
            id: 1,
            title : 'instagram',
            href : 'https://www.instagram.com/elanza.shop',
            icon : '/icons/logo_instagram.svg'
        },
        {
            id: 2,
            title : 'linkedin',
            href : 'https://www.linkedin.com/company/elanza-com/',
            icon : '/icons/LinkedIn_logo_initials.svg'
        },
        {
            id: 3,
            title : 'aparat',
            href : 'https://www.aparat.com/elanza.shop',
            icon : '/icons/Aparat-900x0 1.svg'
        },
    ]
}

//Footer license static data
export const license = [
    {
        id: 1,
        title : '',
        type : 'enamad',
        icon : '/logo/enamad-1.svg'
    },
    {
        id: 2,
        title : '',
        type : 'samandehi',
        icon : '/logo/enamad-2.svg'
    },
]

// Static tab header static data
export const staticTabsHeader = [
    {
        title: OrderProfileEnum.CURRENT,
        value: "CURRENT"
    },
    {
        title: OrderProfileEnum.SENT,
        value: "SENT"
    },
    {
        title: OrderProfileEnum.RETURNED,
        value: "RETURNED"
    },
    {
        title: OrderProfileEnum.CANCELLED,
        value: "CANCELLED"
    },
]

//Months in Perian with their value
export const PersianMonths = [
    {value: 1, label: "فروردین"},
    {value: 2, label: "اردیبهشت"},
    {value: 3, label: "خرداد"},
    {value: 4, label: "تیر"},
    {value: 5, label: "مرداد"},
    {value: 6, label: "شهریور"},
    {value: 7, label: "مهر"},
    {value: 8, label: "آبان"},
    {value: 9, label: "آذر"},
    {value: 10, label: "دی"},
    {value: 11, label: "بهمن"},
    {value: 12, label: "اسفند"}
]

//Profile sidebar items static data
export const sidebarItems = [
    {
        id: 1,
        title: "سفارش های من",
        href: '/profile/order',
        media_type: 'order'
    },
    {
        id: 2,
        title: "کیف پول",
        href: '/profile/wallet',
        media_type: 'wallet'
    },
    {
        id: 3,
        title: "درخواست های تسویه",
        href: '/profile/withdraw',
        media_type: 'withdraw'
    },
    {
        id: 4,
        title: "آدرس ها",
        href: '/profile/address',
        media_type: 'address'
    },
    {
        id: 5,
        title: "علاقه مندی ها",
        href: '/profile/wish',
        media_type: 'wish'
    },
    {
        id: 6,
        title: "اطلاعات حساب کاربری",
        href: '/profile/account/',
        media_type: 'account'
    },
    {
        id: 7,
        title: "کد های تخفیف",
        href: '/profile/voucher',
        media_type: 'voucher'
    },
    {
        id: 8,
        title: "نظرات",
        href: '/profile/comments',
        media_type: 'comments'
    },
    {
        id: 9,
        title: "تیکت ها",
        href: '/profile/ticket',
        media_type: 'ticket'
    },
    {
        id: 10,
        title: "تنظیمات اطلاعیه ها",
        href: '/profile/notification',
        media_type: 'notification'
    },
    {
        id: 11,
        title: "خروج",
        href: '/profile/logout',
        media_type: 'logout'
    }
]

//Some static data like about-us us text or elanza word
export const StaticText = {
    aboutElanza : "" +
        "فروشگاه اینترنتی لوازم آرایشی الانزا عرضه کننده انواع لوازم آرایشی و بهداشتی از برندهای معتبر و با کیفیت\n" +
        "                داخلی و خارجی است که از سال 1398 فعالیت خود را در زمینه فروش آنلاین لوازم آرایشی و بهداشتی آغاز کرده و\n" +
        "                با\n" +
        "                توجه به مدت زمان کوتاه فعالیتش، توانسته سهم بزرگی را در این مارکت به خود اختصاص دهد. این سایت لوازم\n" +
        "                آرایشی\n" +
        "                با هدف فراهم کردن تمامی نیازهای آرایشی و بهداشتی که یک فرد در جهت حفظ زیبایی و بهبود بهداشت فردی خود به\n" +
        "                آن\n" +
        "                ها احتیاج دارد، تلاش می کند تا محصولات با کیفیتی را در اختیار شما خریداران محترم قرار دهد خوشبختانه خرید\n" +
        "                لوازم آرایشی از این سایت به دسته یا برند خاصی محدود نمی شود و شما خریداران عزیز می توانید تنها با چند\n" +
        "                کلیک،\n" +
        "                تمامی محصولات آرایشی و بهداشتی مورد نظر خود مانند سایه چشم، رژ گونه، پنکک، ماسک صورت، شامپو، دئودورانت،\n" +
        "                ضد\n" +
        "                آفتاب، لوسیون بدن و ... را با مناسب ترین قیمت لوازم آرایشی از الانزا تهیه کنید. محصولات موجود در سایت\n" +
        "                لوازم\n" +
        "                آرایشی الانزا علاوه بر تنوع بالا، دارای کیفیت مطلوب و ضمانت اصالت کالا نیز هستند. برای مثال معمولاً خرید\n" +
        "                عطر\n" +
        "                و ادکلن به صورت آنلاین و بدون استشمام برای برخی افراد دور از ذهن به نظر می رسد؛ اما کیفیت بالای عطر و\n" +
        "                ادکلن\n" +
        "                های الانزا، قطعاً تجربه ای عالی را در این زمینه برای شما به وجود می آورند. همچنین فروشگاه اینترنتی لوازم\n" +
        "                آرایشی و بهداشتی الانزا، جهت رضایت مصرف کنندگان علاوه بر تحویل تمامی سفارشات درب منزل، امکان پیگیری روند\n" +
        "                ارسال و پشتیبانی محصولات را نیز برای خریداران فراهم آورده است. از این رو خریداران عزیز می توانند با\n" +
        "                شماره\n" +
        "                تماس 02191008292 _ 02188203882 و یا از طریق شبکه های اجتماعی نسبت به پیگیری سفارشات خود اقدام کنند.",
    Elanza:"الانزا",
    searchFor:"جستجو برای"
}